<template>
  <wrapper
    v-if="!isLoading"
    :backgroundImage="configuratorData.CityMap ? assets.getUrl(configuratorData.CityMap.url) : ''"
    class="wrapper"
  >
    <router-view></router-view>
  </wrapper>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import wrapper from '@/components/common/wrapper';
import { setConversionCookie } from '@/utils/tracking';
import { assets } from '@/agent';

export default {
  components: {
    wrapper,
  },

  computed: {
    ...mapGetters({
      configuratorData: 'configurators/getConfiguratorData',
    }),
  },

  data() {
    return {
      assets,
      isLoading: true,
      configuratorUID: this.$route.params.configuratorUID,
    };
  },

  async mounted() {
    setConversionCookie(this.$route.query);
    this.isLoading = true;
    await this.fetchConfiguratorData({ configuratorUID: this.configuratorUID });
    // due we get theme informations based on configurator fetch we need to set it here
    this.setTheme({
      primaryColor: this.configuratorData.PrimaryColor,
      secondaryColor: this.configuratorData.SecondaryColor,
      logoUrl: this.configuratorData.CityLogo.url,
    });
    this.setFooterLinks({
      imprintLink: this.configuratorData.ImprintLink,
      privacyLink: this.configuratorData.PrivacyLink,
    });
    this.isLoading = false;
  },

  methods: {
    ...mapActions({
      fetchConfiguratorData: 'configurators/fetchConfiguratorData',
      setTheme: 'general/setTheme',
      setFooterLinks: 'general/setFooterLinks',
    }),
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  min-height: 100vh;
  padding: 2rem 0;
}
</style>
